import { useAgentRuntime } from '@/context/AgentProvider'
import type { ToolCallDebugProps } from './types'
import { formatDebugJson } from './utils'

export const ToolCallDebug = ({ call }: ToolCallDebugProps) => {
  const runtime = useAgentRuntime()

  if (!runtime.config.debug) return null

  return (
    <details className='mp-agent-tool-debug-details'>
      <summary className='mp-agent-tool-debug-summary'>Details</summary>
      <div className='mp-agent-tool-debug-body'>
        <div className='mp-agent-tool-debug-row'>
          <div className='mp-agent-tool-debug-label'>Tool</div>
          <div className='mp-agent-tool-debug-value'>{call.name}</div>
        </div>
        <div className='mp-agent-tool-debug-row'>
          <div className='mp-agent-tool-debug-label'>Status</div>
          <div className='mp-agent-tool-debug-value'>{call.status}</div>
        </div>

        <details className='mp-agent-tool-debug-section'>
          <summary className='mp-agent-tool-debug-section-summary'>Input</summary>
          <pre className='mp-agent-tool-debug-code'>
            <code>{formatDebugJson(call.input)}</code>
          </pre>
        </details>

        <details className='mp-agent-tool-debug-section'>
          <summary className='mp-agent-tool-debug-section-summary'>Output</summary>
          <pre className='mp-agent-tool-debug-code'>
            <code>{formatDebugJson(call.output)}</code>
          </pre>
        </details>

        {call.error && (
          <details className='mp-agent-tool-debug-section'>
            <summary className='mp-agent-tool-debug-section-summary'>Error</summary>
            <pre className='mp-agent-tool-debug-code'>
              <code>{formatDebugJson(call.error)}</code>
            </pre>
          </details>
        )}
      </div>
    </details>
  )
}
